// // src/components/Nav.js
// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FaHome, FaBriefcase, FaHeart, FaUser, FaBars, FaTimes } from "react-icons/fa";
// import "./Nav.css";

// function Nav() {
//   const location = useLocation();
//   const [menuOpen, setMenuOpen] = useState(false);

//   const navItems = [
//     { path: "/", label: "Home", icon: <FaHome /> },
//     { path: "/servicehome", label: "Services", icon: <FaBriefcase /> },
//     { path: "/like", label: "Like", icon: <FaHeart /> },
//     { path: "/profile", label: "Profile", icon: <FaUser /> },
//   ];

//   useEffect(() => {
//     document.body.style.overflow = menuOpen ? "hidden" : "auto";
//   }, [menuOpen]);

//   return (
//     <nav className="navbar">
//       <Link to="/" className="navbar-brand">
//         <img src="/images/only logoroot.png" alt="Root Services Logo" className="brand-logo" />
//         <span className="brand-text">ʀᴏᴏᴛ ꜱᴇʀᴠɪᴄᴇꜱ</span>
//       </Link>

//       <button
//         className={`navbar-toggle ${menuOpen ? "open" : ""}`}
//         onClick={() => setMenuOpen(!menuOpen)}
//       >
//         {menuOpen ? <FaTimes /> : <FaBars />}
//       </button>

//       <div className={`navbar-menu ${menuOpen ? "open" : ""}`}>
//         {navItems.map((item) => (
//           <Link
//             key={item.path}
//             to={item.path}
//             onClick={() => setMenuOpen(false)}
//             className={`navbar-link ${location.pathname === item.path ? "active" : ""}`}
//           >
//             <div className="navbar-icon">{item.icon}</div>
//             <span className="label">{item.label}</span>
//             <span className="underline"></span>
//           </Link>
//         ))}
//       </div>
//     </nav>
//   );
// }

// export default Nav;
 // src/components/Nav.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaBriefcase, FaHeart, FaUser, FaBars, FaTimes } from "react-icons/fa";
import "./Nav.css";

function Nav() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home", icon: <FaHome /> },
    { path: "/servicehome", label: "Services", icon: <FaBriefcase /> },
    { path: "/like", label: "Like", icon: <FaHeart /> },
    { path: "/profile", label: "Profile", icon: <FaUser /> },
  ];

  // Prevent scrolling when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img src="/images/only logoroot.png" alt="Root Services Logo" className="brand-logo" />
        <span className="brand-text">ʀᴏᴏᴛ ꜱᴇʀᴠɪᴄᴇꜱ</span>
      </Link>

      <button
        className={`navbar-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`navbar-menu ${menuOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => setMenuOpen(false)}
            className={`navbar-link ${location.pathname === item.path ? "active" : ""}`}
          >
            <div className="navbar-icon">{item.icon}</div>
            <span className="label">{item.label}</span>
            <span className="underline"></span>
          </Link>
        ))}
      </div>
    </nav>
  );
}

export default Nav;
